import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { Exame } from "../types/exames";

export const defaultValuesList = {
  data: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalData: 0
  }
}

interface ExameZusProps {
  exames: {
    data: Exame[];
    pagination: {
      currentPage: number;
      totalPages: number;
      totalData: number;
    };
  };
  selectedExame: Exame | undefined;
  selectedSchoolId: number | undefined;
  setExames: (exames: { data: Exame[]; pagination: any }) => void;
  setSelectedExame: (exame: Exame) => void;
  setSelectedSchoolId: (schoolId: number | undefined) => void;
  resetState: () => void;
  removeExame: (id: number) => void;
  updateExame: (exame: Exame) => void;
}

const useExameStore = create<ExameZusProps>()(
  persist(
    (set, get) => ({
      exames: defaultValuesList,
      selectedExame: undefined,
      selectedSchoolId: undefined,
      setExames: (examesResponse) => {
        set({
          exames: {
            data: examesResponse.data || [],
            pagination: examesResponse.pagination || defaultValuesList.pagination
          }
        });
      },
      setSelectedExame: (exame: Exame) => {
        set({
          selectedExame: exame
        });
      },
      setSelectedSchoolId: (schoolId: number | undefined) => {
        set({
          selectedSchoolId: schoolId
        });
      },
      resetState: () => {
        set({
          exames: defaultValuesList,
          selectedExame: undefined,
          selectedSchoolId: undefined
        });
      },
      removeExame: (id: number) => {
        const { exames } = get();
        const newState = {
          ...exames,
          data: exames.data.filter((item) => item.id !== id)
        };
        set({
          exames: newState
        });
      },
      updateExame: (exame: Exame) => {
        const { exames } = get();
        const newState = {
          ...exames,
          data: exames.data.map((item) =>
            exame.id === item.id ? exame : item
          )
        };
        set({
          exames: newState,
          selectedExame: exame
        });
      }
    }),
    {
      name: "exames",
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);

export default useExameStore;
